import React from 'react';
import { Badge, BadgeTone } from '../../components/ui';
import { t } from '../../i18n';
import { OrderStatus } from './types';

const TONE: Record<OrderStatus, BadgeTone> = {
  completo: 'success',
  aguardando: 'warning',
  incompleto: 'danger',
};

export const StatusBadge: React.FC<{ status: OrderStatus }> = ({ status }) => (
  <Badge tone={TONE[status]}>{t(`savedOrders.status.${status}`)}</Badge>
);
